module.exports = __webpack_public_path__ + "static/b2b_mobile_bottom-cbf02f7053a1997d3f1b95c0c6c0daab.png";